seedWebApp.controller('StagesController', ['$scope', '$rootScope', '$uibModal', 'ToastService', 'TranslationService', 'HelpdeskService',
    function ($scope, $rootScope, $uibModal, ToastService, TranslationService, HelpdeskService) {
        console.log('stagesController');

        $scope.translation = TranslationService.getActiveTranslation();
        $scope.prefs = {
            name: 'DocTypesGrid',
            sortByCol: null,
            canAdd: true,
            canEdit: true,
            canDelete: false,
            parentFilter: false, //showDisabled
        };
        $scope.showDisabled = false;

        $scope.idClass = function (item) {
            return 'agp-color';
        };

        $scope.seqClass = function (item) {
            return 'sd-border-label';
        };     

        $scope.countClass = function (item) {
            if (item) {
                return 'user-anybody';
            }
        };

        $scope.statusClass = function (item) {
            return 'status-issue';
        };

        $scope.statusStyle = function (value, item) {                        
            if (item) {
                return 'color: ' + item.ForeColor + ';background-color: ' + item.BackColor + '; padding:1.5px 5px 1.5px 5px; border-radius:4px; ';
            }
            else {
                return '';
            }
        };

        $scope.columns = [
            { name: 'StageID', display: 'ID', orderBy: 'asc', editable: false, width: 10, isKey: true, customClass: $scope.idClass },  //filterOptions: [] 
            { name: 'StageName', display: 'Nome', editable: true, width: 15, customStyle: $scope.statusStyle, customClass: $scope.statusClass },
            { name: 'Sequence', display: 'Seq', editable: true, width: 5 },
            { name: 'ForeColor', display: 'Cor Fonte', editable: true, width: 5, dataType: 'color' },
            { name: 'BackColor', display: 'Cor Fundo', editable: true, width: 5, dataType: 'color' },            
            { name: 'AssignedUserIDs', display: 'Users', width: 5, dataType: 'avatars' },
            { name: 'ApprovalsCount', display: 'Approvals', width: 5, customClass: $scope.countClass },
            { name: 'Stages', display: 'Stages', width: 5, dataType: 'tags' },
            
            { name: 'IsSendEmail', display: 'Enviar Email', dataType: 'boolean', width: 1 }, 
            { name: 'IsClosed', display: 'Closed', dataType: 'boolean', width: 1 },
            { name: 'IsApproved', display: 'Approved', dataType: 'boolean', width: 1 },
            { name: 'IsEnabled', display: 'Enabled', dataType: 'boolean', width: 1 },  
            { name: 'HasCreditNote', display: 'Tem Custo', dataType: 'boolean', width: 1 },                           
        ];

        $scope.prefs.sortByCol = $scope.columns[0];
        $scope.prefs.sortByCol.orderReverse = false;

        $scope.loadService = HelpdeskService.searchStages;
        $scope.resetService = HelpdeskService.resetCache;
        //$scope.loadColumns = ContactService.getContactsColumns;

      

        $scope.searchMode = function () {
            $scope.$broadcast('inputSearch', $scope.filterString);
        };

        $scope.doRefresh = function () {
            $scope.$broadcast('refreshServiceGrid');
        };

        $scope.toExcel = function () {
            $scope.$broadcast('toExcel', 'stages');
        };

        $scope.prefs.customEdit = function (item) {
            docTypeModalResult(openModalStage(item));
        };

        $scope.doInsert = function () {
            docTypeModalResult(openModalStage());
        };

        function openModalStage(item) {
            return $uibModal.open({
                templateUrl: './SPA/Settings/Stages/stageModal.html' + seedWebApp.buildVersion,
                controller: 'StageModalCtrl as ctrl',
                size: 'lg',
                resolve: {                    
                    item: function () {
                        return item ? item : {};
                    },
                    translation: function () {
                        return $scope.translation;
                    },
                    isEdit: function () {
                        return item ? true : false;
                    }
                }
            });
        }

        function docTypeModalResult(modalInstance) {
            modalInstance.result.then(function () {
                $scope.doRefresh();
            });
        }
    }
]);

